import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { AUTH_UNAUTHORIZED_EVENT } from '@/services/authUnauthorized'

/**
 * Listens for 401 Unauthorized from API calls and logs the user out,
 * then redirects to sign-in so they can log in again.
 */
export function AuthListener() {
  const navigate = useNavigate()
  const logout = useAuthStore((s) => s.logout)

  useEffect(() => {
    const handleUnauthorized = () => {
      logout()
      navigate('/sign-in', { replace: true })
    }

    window.addEventListener(AUTH_UNAUTHORIZED_EVENT, handleUnauthorized)
    return () => window.removeEventListener(AUTH_UNAUTHORIZED_EVENT, handleUnauthorized)
  }, [logout, navigate])

  return null
}
